import {PageHeader} from 'pepsico-ds'
import {PageContainer} from '@/components/organisms'
import {ActivitiesListTable} from '@/containers'

export const ActivitiesList = () => {
  return (
    <div>
      <div className="flex flex-row justify-between">
        <PageHeader title="Activities" />
        {/* <Button>Add Activity</Button> */}
      </div>
      <PageContainer data-testid="activities-list-page-content">
        <ActivitiesListTable />
      </PageContainer>
    </div>
  )
}
